type LayloSubscribeDetails = {
  email?: string;
  phoneNumber?: string;
  optIn?: string;
  phoneOptIn?: boolean;
};

export const useLaylo = (apiKey: string) => {
  const layloRequest = (body: object) => {
    fetch('https://laylo.com/api/graphql', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${apiKey}` },
      body: JSON.stringify(body),
    });
  };

  const subscribe = ({ email, phoneNumber, optIn, phoneOptIn }: LayloSubscribeDetails) => {
    if (optIn) {
      layloRequest({
        query: 'mutation subscribeToUser($email: String!) { subscribeToUser(email: $email) }',
        variables: { email },
      });
    }

    if (phoneOptIn && phoneNumber && phoneNumber != '') {
      layloRequest({
        query: 'mutation subscribeToUser($phoneNumber: String!) { subscribeToUser(phoneNumber: $phoneNumber) }',
        variables: { phoneNumber },
      });
    }
  };

  return {
    subscribe,
  };
};
